package hk.com.vr360_demo2.webapp.component

import cc.easyandroid.easycompose.component.DefaultComponentContext
import cc.easyandroid.easycompose.component.router.stack.ChildStack
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigationOwner
import cc.easyandroid.easycompose.component.value.Value
import cc.easyandroid.easycompose.core.lifecycle.LifecycleRegistry
import hk.com.vr360_demo2.webapp.component.editor_rewrite.EditorRewriteComponent
import hk.com.vr360_demo2.webapp.component.home.HomeComponent
import hk.com.vr360_demo2.webapp.component.previewer.PreviewerComponent
import hk.com.vr360_demo2.webapp.component.verification.VerificationComponent
import hk.com.vr360_demo2.webapp.component.viewer.ViewerComponent

interface AppComponent : WebNavigationOwner{
    val stack: Value<ChildStack<*, Child>>
    fun navigateToHome()
    sealed class Child {
        class HomeChild(val component: HomeComponent) : Child()
        class ViewerChild(val component: ViewerComponent) : Child()
        class PreviewerChild(val component: PreviewerComponent) : Child()
        class EditorRewriteChild(val component: EditorRewriteComponent) : Child()
        class VerificationChild(val component: VerificationComponent) : Child()
    }
}


